module.exports = __webpack_public_path__ + "media/images/xxxioscor-logo-1ca4ea6c7f1fffacc1dca424b0f03e36.jpg";